import { __assign } from "tslib";
import React, { Fragment } from 'react';
import { IconSVG } from '../icon-svg/icon-svg';
export var IconDealership = function (SVGprops) {
    return (React.createElement(IconSVG, __assign({}, SVGprops),
        React.createElement(Fragment, null,
            React.createElement("path", { d: "m20.6 3.3h-19.7v17.5h21.9v-17.5zm-13.1 15.3v-6.6h3.3v6.6zm5.5 0v-6.6h3.3v6.6zm5.4 0v-8.7h-13.1v8.7h-2.2v-12c1.2 0 2.2-1 2.2-2.2 0 1.2 1 2.2 2.2 2.2s2.2-1 2.2-2.2c0 1.2 1 2.2 2.2 2.2s2.2-1 2.2-2.2c0 1.2 1 2.2 2.2 2.2s2.2-1 2.2-2.2c0 1.2 1 2.2 2.2 2.2v12z" }))));
};
